
import { Bot, Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { ChatModal } from "./ChatModal";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState, useEffect } from "react";
import { openPopoutWindow } from "@/utils/popoutWindow";

export const ChatButton = () => {
  const isMobile = useIsMobile();
  const [isPopout, setIsPopout] = useState(false);
  const [popoutWindow, setPopoutWindow] = useState<Window | null>(null);

  useEffect(() => {
    const handlePopoutClose = () => {
      if (popoutWindow?.closed) {
        setIsPopout(false);
        setPopoutWindow(null);
      }
    };

    const interval = setInterval(handlePopoutClose, 500);
    return () => clearInterval(interval);
  }, [popoutWindow]);

  const handlePopout = () => {
    const newWindow = openPopoutWindow("/chat-popout", "BrigAI Assistant");
    if (newWindow) {
      setIsPopout(true);
      setPopoutWindow(newWindow);
    }
  };

  // Don't show the button if it's already popped out
  if (isPopout) return null;

  if (isMobile) {
    return (
      <Drawer>
        <DrawerTrigger asChild>
          <Button
            size="lg"
            className="fixed bottom-4 right-4 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-shadow bg-primary text-primary-foreground z-50"
          >
            <Bot className="h-6 w-6" />
            <span className="sr-only">Open BrigAI Chat</span>
          </Button>
        </DrawerTrigger>
        <DrawerContent className="h-[92vh]">
          <ChatModal />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          size="lg"
          className="fixed bottom-4 right-4 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-shadow bg-primary text-primary-foreground z-50"
        >
          <Bot className="h-6 w-6" />
          <span className="sr-only">Open BrigAI Chat</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[90vw] sm:w-[550px] p-0 sm:max-w-md md:max-w-xl">
        <div className="h-full relative">
          <Button
            size="icon"
            variant="ghost"
            className="absolute right-2 top-2 z-50"
            onClick={handlePopout}
          >
            <Maximize2 className="h-4 w-4" />
            <span className="sr-only">Pop out chat</span>
          </Button>
          <ChatModal />
        </div>
      </SheetContent>
    </Sheet>
  );
};
